import type { ApiMagentoConsumableMatrixItemStrengthDetails } from "@jti/magento-types";

import type { ConsumableMatrixItem } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

const matchesCurrentAttributes = (item: ConsumableMatrixItem, currentMatrixItem: ConsumableMatrixItem): boolean => {
  return (
    item.flavorDetails.flavour === currentMatrixItem.flavorDetails.flavour &&
    item.packagingFormatId === currentMatrixItem.packagingFormatId &&
    item.purchaseType === currentMatrixItem.purchaseType
  );
};

export const getAvailableStrengths = (
  consumablesMatrixItems: ConsumableMatrixItem[],
  currentMatrixItem: ConsumableMatrixItem
): ApiMagentoConsumableMatrixItemStrengthDetails[] => {
  const matchingItems = consumablesMatrixItems.filter(
    (item) => !!item.strengthDetails && matchesCurrentAttributes(item, currentMatrixItem)
  );

  const uniqueStrengthsByRating = matchingItems
    .map((item) => item.strengthDetails)
    .filter((strengthDetails) => !!strengthDetails);

  return uniqueStrengthsByRating.sort((a, b) => a.rating - b.rating);
};
